import * as _ from 'lodash'
import React from 'react';
import * as contractorActions from '../contractorActions';
import componentServices from '../componentServices';
import globalRelay from '../globalRelay';
import util from '../util';
import * as employeeActions from '../employeeActions';
import enums from '../enum';
import * as actions from '../actions';
import NewEstimateModal from './jobCostCreateModal';
import CombinedContractModal from './jobPrintCombinedContract';
import JobCostSummary from '../models/jobCostSummary';
import { ContractorLockSection, sortableComponent } from './sharedComponents';
import { getCollection, getModel, ModelCollection } from 'Scripts/store';

class EstimateTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.handleClick = this.handleClick.bind(this);
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		this.setState(this.getStateFromProps(nextProps));
	}

	handleClick (e) {
		e.preventDefault();
		componentServices.router.pushHistory(componentServices.router.pushPathSegments(this.props.jobCost.key, 'setup'));
	}

	getStateFromProps (props) {
		const nextState = _.assign({}, this.state);

		if (props.jobCost.createdById !== nextState.lastCreatedById) {
			nextState.lastCreatedById = props.jobCost.createdById;

			const employee = employeeActions.getEmployeeByUserKey(props.jobCost.createdById);

			if (!employee) {
				employeeActions.fetchEmployee({ userKey: props.jobCost.createdById });
			}
		}

		return nextState;
	}

	render () {
		const { jobCost } = this.props;
		const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
		const employee = employeeActions.getEmployeeByUserKey(jobCost.createdById);
		const numberRow = globalRelay.config!.variants.length > 1 && globalConfig.badge ? <td>{jobCost.relayNumber} <span className="badge" style={{ backgroundColor: globalConfig.badge.color }}><span>{ globalConfig.badge.label }</span></span></td> : <td>{jobCost.relayNumber}</td>;

		return (
			<tr key={jobCost.key} onClick={this.handleClick}>
				<td />
				<td>{jobCost.name}</td>
				<td>{jobCost.workAreaCount}</td>
				<td>{util.formatAsCurrency(jobCost.totalCost)}</td>
				<td>{ employee ? employee.fullName : 'Unknown' }</td>
				<td>{util.dateHelper.formatDate(jobCost.dateCreated, { userFriendly: true })}</td>
				<td>{util.dateHelper.formatDate(jobCost.dateLastModified, { userFriendly: true })}</td>
				{ numberRow }
				<td />
				<td />
			</tr>
		);
	}
}

const EstimateTable = sortableComponent(class EstimateTableInner extends React.PureComponent<any,any> {
	handleClick (path, e) {
		e.preventDefault();

		this.props.updateSort(path);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, store, ...childProps } = this.props;
		const rows:JSX.Element[] = [];

		list.forEach((jobCost) => {
			rows.push(<EstimateTableRow jobCost={jobCost} key={jobCost.key} store={ store} {...childProps} />);
		});

		return (
			<table className="sortable interactive" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Estimate Name</td>
						<td className={this.getClassName('workAreaCount')} onClick={this.handleClick.bind(this, 'workAreaCount')}>Work Areas</td>
						<td className={this.getClassName('totalCost')} onClick={this.handleClick.bind(this, 'totalCost')}>Total So Far</td>
						<td className={this.getClassName('employeeName')} onClick={this.handleClick.bind(this, 'employeeName')}>Created by</td>
						<td className={this.getClassName('dateCreated')} onClick={this.handleClick.bind(this, 'dateCreated')}>Created on</td>
						<td className={this.getClassName('dateLastModified')} onClick={this.handleClick.bind(this, 'dateLastModified')}>Modified</td>
						<td className={this.getClassName('relayNumber')} onClick={this.handleClick.bind(this, 'relayNumber')}>Relay No.</td>
						<td />
						<td />
					</tr>
				</thead>
				<tbody>
					{ rows }
				</tbody>
			</table>
		);
	}
});

export default class JobEstimatesList extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.handleAddEstimateClick = this.handleAddEstimateClick.bind(this);
		this.handleDesignRetainerClick = this.handleDesignRetainerClick.bind(this);
		this.handleCombinedContractClick = this.handleCombinedContractClick.bind(this);
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		this.setState(this.getStateFromProps(nextProps));
	}

	getStateFromProps (props) {
		const { job } = props;
		const { store } = componentServices;
		const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts });
		const state = _.assign({ canPrintCombinedContract: false, canCreateItems: false }, this.state);
		const estimates:any[] = [];
		let combinedContractCandidates = 0;

		if (jobCosts && jobCosts.count()) {
			jobCosts
				.filter(jc => {
					return jc.jobKey === job.key && !jc.isContract;
				})
				.forEach(jc => {
					const summary = new JobCostSummary(jc, job.getAppliedPaymentTotal(jc.key));
					const result = jc.toDocument();

					if (jc.currentStatus === 'locked') {
						combinedContractCandidates++;
					}

					summary.buildItems();
					result.totalCost = summary.grandTotalSell;
					result.workAreaCount = (result.workAreas) ? result.workAreas.length : 0;
					result.relayNumber = jc.relayNumber;
					result.companyVariant = jc.companyVariant;

					estimates.push(result);
				});
		}

		if (combinedContractCandidates > 1 && (!state.builder || state.builder.currentStatus !== 'locked')) {
			state.canPrintCombinedContract = true;
		}

		if (job.builderKey) {
			if (!state.builder || state.builder.key !== job.builderKey) {
				state.builder = getModel({ store, collection: ModelCollection.contractors, key: job.builderKey });
				if (!state.builder) {
					if (state.fetchedBuilderKey !== job.builderKey) {
						// this prevents endless fetch calls if the builder somehow went missing
						state.fetchedBuilderKey = job.builderKey;
						contractorActions.fetchContractor({ key: job.builderKey });
					}
				}
				else {
					state.fetchedBuilderKey = undefined;
				}
			}
		}
		else {
			state.builder = undefined;
		}

		state.job = job;
		state.estimates = estimates;
		//all jobs now require both addresses before estimates can be created
		state.canCreateItems = (!!job.workSiteAddress && !!job.billingAddress) || !!globalRelay.config!.jobCostSettings.allowEstimatesWithoutAddress;

		return state;
	}

	handleDesignRetainerClick (e) {
		e.preventDefault();

		if (typeof window !== 'undefined') {
			window.open(`https://s3-us-west-2.amazonaws.com/relay-live/${globalRelay.config!.companyKey}/static/Design_Retainer.docx`);
		}
	}

	handleAddEstimateClick () {
		const { job, store } = this.props;
		const { builder } = this.state;
		const globalConfig = globalRelay.config!;
		const builderTemplates:any[] = [];

		if (builder) {
			const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts});
			jobCosts.forEach(jc => {
				if (jc.contractorKey === builder.key) {
					builderTemplates.push(jc);
				}
			});
		}

		if ((builder && builderTemplates.length) || globalConfig.variants.length > 1 || job.requiresInitialization) {
			actions.pushModal({
				component: (<NewEstimateModal close={ actions.popModal} jobKey={job.key} contractorTemplates={ builderTemplates } />)
			});
		}
		else {
			componentServices.router.pushHistory(componentServices.router.pushPathSegments(util.generateGuid(), 'setup'));
		}
	}

	handleCombinedContractClick () {
		const { job } = this.props;

		actions.pushModal({
			component: (<CombinedContractModal job={ job } close={ actions.popModal } />),
			rendersAlerts: true
		});
	}

	render () {
		const { builder, canPrintCombinedContract, canCreateItems } = this.state;
		const buttonClass = (builder && builder.currentStatus === 'locked') || !canCreateItems ? 'disabled' : '';
		const combinedContractClass = 'iconLabel printCombinedContract' + (!canPrintCombinedContract ? ' disabled' : '');
		const hideDesignRetainer = globalRelay.config!.jobCostSettings.hideDesignRetainer;

		return (
			<React.Fragment>
				<ContractorLockSection contractor={ builder } />
				<section>
					<div className="inner">

						<EstimateTable list={ this.state.estimates } initialSortKey="name" store={ this.props.store }/>

						<button className={ `iconLabel addEstimate ${buttonClass}` } onClick={ this.handleAddEstimateClick }><span>New Estimate</span></button>
						{ hideDesignRetainer ? null : <button className={ `iconLabel addDesignRetainer ${buttonClass}` } onClick={ this.handleDesignRetainerClick }><span>New Design Retainer</span></button> }
						<button className={ combinedContractClass } onClick={ this.handleCombinedContractClick }><span>Print Combined Contract</span></button>

					</div>
				</section>
			</React.Fragment>
		);
	}
}